import { render } from "./DetailsPanels.vue?vue&type=template&id=5e91bb16&ts=true"
import script from "./DetailsPanels.vue?vue&type=script&lang=ts&setup=true"
export * from "./DetailsPanels.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/DetailsPanels.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5e91bb16"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5e91bb16', __exports__)) {
    console.log('reload')
    api.reload('5e91bb16', __exports__)
  }
  
  module.hot.accept("./DetailsPanels.vue?vue&type=template&id=5e91bb16&ts=true", () => {
    console.log('re-render')
    api.rerender('5e91bb16', render)
  })

}


export default __exports__